export const REALTIME_NAMESPACE = 'realtime';

export const ROOMS = {
  PENDING_CLEANINGS_BADGE: 'PENDING_CLEANINGS_BADGE',
  PENDING_TASKS_BADGE: 'PENDING_TASKS_BADGE',
  PENDING_PAYMENTS_BADGE: 'PENDING_PAYMENTS_BADGE',
  PROBLEM_ISSUES_BADGE: 'PROBLEM_ISSUES_BADGE',
  CLEANER_LIST_INVALIDATION: 'CLEANER_LIST_INVALIDATION'
} as const;

export type RealtimeRoomName = (typeof ROOMS)[keyof typeof ROOMS];

export const REALTIME_EVENT = {
  MENU_CLEANING_BADGES_UPDATED: 'menu.cleaning.badges.updated',
  MENU_TASK_BADGES_UPDATED: 'menu.task.badges.updated',
  MENU_PAYMENT_BADGES_UPDATED: 'menu.payment.badges.updated',
  MENU_ISSUE_BADGE_INVALIDATED: 'menu.issue.badge.invalidated',
  CLEANER_LIST_INVALIDATED: 'cleaner.list.invalidated'
} as const;

export const REALTIME_INTERNAL_EVENT = {
  USER_CONNECTED: 'realtime.user.connected',
  USER_DISCONNECTED: 'realtime.user.disconnected'
} as const;

export type RealtimeServerEvent = (typeof REALTIME_EVENT)[keyof typeof REALTIME_EVENT];

export type RealtimeUserMetadata = {
  name: string;
  ownerId?: string;
  cleanerId?: string;
  language?: string;
};

export type AuthenticatedRealtimeUser = {
  id: string;
  email: string;
  name: string;
  roles: string[];
  metadata: RealtimeUserMetadata;
};

export type MenuBadgeSnapshot = {
  pendingCleanings: number;
  pendingTasks: number;
  pendingPayments: number;
  problemIssues: number;
};

export type CleaningMenuBadgePayload = Pick<MenuBadgeSnapshot, 'pendingCleanings'>;

export type TaskMenuBadgePayload = Pick<MenuBadgeSnapshot, 'pendingTasks'>;

export type PaymentMenuBadgePayload = Pick<MenuBadgeSnapshot, 'pendingPayments'>;

export type IssueMenuBadgeInvalidationPayload = {
  invalidatedAt: number;
};

export type CleanerListInvalidationPayload = {
  invalidatedAt: number;
};
